import React, { useState, useRef, useEffect } from 'react';
import '../../assets/vendor/css/pages/page-auth.css'
import { Link, useNavigate } from 'react-router-dom';

import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../helpers/api_helper';
import { getToken, setUserSession } from '../../helpers/Helper';
import { POST_LOGIN } from '../../helpers/url_helper';
import { toast } from 'react-toastify';

import Auth_Img from './../../assets/img/auth_img.png';
import Logo from './../../assets/img/logo.svg';

const Login = (props) => {
    const navigate = useNavigate();
    useEffect(() => {
        if (getToken()) {
            navigate("/dashboard");
        }
    }, [navigate])


    const simpleValidator = useRef(new SimpleReactValidator());

    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [login_inputs, setInputs] = useState({ email: '', password: '', otp: '', otp_screen: false });
    const [, forceUpdate] = useState();

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_LOGIN, login_inputs, {});
            if (res_data.status) {
                setUserSession(res_data.data.userInfo.token, res_data.data.userInfo);
                navigate("/dashboard");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...login_inputs, [event.target.name]: event.target.value }));
    }

    return (
        <>
            <div>

            </div>
            <div className="authentication-wrapper authentication-cover">
                <div className="authentication-inner row m-0">
                    <div className="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center p-5">
                        <div className="w-100 d-flex justify-content-center">
                            <img src={Auth_Img} className="img-fluid" alt="Login" width="700" />
                        </div>
                    </div>

                    <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-5 p-4">
                        <div className="w-px-400 mx-auto">
                            <div className="app-brand mb-4">
                                <img src={Logo} alt='Logo' />
                            </div>
                            <h4 className="mb-2">Welcome to MR Jewellery! 👋</h4>
                            <p className="mb-4">Please sign-in to your account and start the adventure</p>

                            <form className="mb-3" onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label for="email" className="form-label">Email Address</label>
                                    <input name="email" value={login_inputs.email} onChange={handleInputChange} className="form-control" placeholder="Enter Email Address" type="text" />
                                    {simpleValidator.current.message('email', login_inputs.email, 'required|email')}
                                </div>
                                <div className="mb-3 form-password-toggle">
                                    <div className="d-flex justify-content-between">
                                        <label className="form-label" for="password">Password</label>
                                        <Link to="/forgot-password">
                                            <small>Forgot Password?</small>
                                        </Link>
                                    </div>
                                    <div className="input-group input-group-merge">
                                        <input name="password" value={login_inputs.password} onChange={handleInputChange} type="password" className="form-control" placeholder="Enter Password" />
                                    </div>
                                    {simpleValidator.current.message('password', login_inputs.password, 'required')}
                                </div>

                                <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2 w-100">
                                    {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Sign in
                                </button>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Login;